import React from 'react';
import { Tooltip } from 'react-tooltip';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

export const DiscountStatusCircle = ({ discountIsActive }: { discountIsActive: boolean }) => {
  const { t } = useTranslation();

  const id = `tooltip-discount-status-${uuid()}`;
  return (
    <>
      <Tooltip
        place="bottom"
        content={discountIsActive ? t('discounts.active') : t('discounts.notActive')}
        id={id}
        variant="light"
        border="1px solid black"
      />

      <Grid
        data-tooltip-id={id}
        sx={{ width: 8, height: 8, borderRadius: '2px', bgcolor: discountIsActive ? 'primary.main' : 'text.disabled' }}
      />
    </>
  );
};
